module.exports = __webpack_public_path__ + "static/gamma-65309503439d28e24fd5ab4e2c122f29.svg";